import { useEffect } from 'react';
import { useTypedSelector } from '@Features/store';

const TITLE_SUFFIX = 'Admin Portal';

/**
 * Applies the admin-configurable branding to the browser tab:
 * document title from app_settings.meta_title and favicon from the
 * "favicon" asset. When either is unset the static index.html
 * defaults are left untouched.
 */
const useBrowserTabInit = () => {
	const { assets, meta_title } = useTypedSelector((state) => state.settings);

	useEffect(() => {
		if (meta_title) document.title = `${meta_title} | ${TITLE_SUFFIX}`;
	}, [meta_title]);

	useEffect(() => {
		if (!assets.favicon) return;
		let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
		if (!link) {
			link = document.createElement('link');
			link.rel = 'icon';
			document.getElementsByTagName('head')[0].appendChild(link);
		}
		link.href = assets.favicon;
	}, [assets.favicon]);
};

export default useBrowserTabInit;
